// @flow
import React, { Component, type ComponentType } from "react";

import dateFormat from "../utils/localdateformat";
import { Outer, Blogs, Blog, Date, Title } from "./styled";
import { decode } from "../utils/string";

type Props = {|
    blogs: ComponentType<any>,
    onShowBlog: Function
|};

class JournalsPageView extends Component<Props> {
    render() {
        const { blogs } = this.props;

        return (
            <Outer>
                <Blogs>
                    {blogs.map(blog => (
                        <Blog key={blog.id} onClick={() => this.props.onShowBlog(blog)}>
                            <Date>{dateFormat(blog.startDate, "mmm dS yyyy")}</Date>
                            <Title>{decode(blog.title)}</Title>
                        </Blog>
                    ))}
                </Blogs>
            </Outer>
        );
    }
}

export default JournalsPageView;



// WEBPACK FOOTER //
// ./src/journals-page-view/view.js